import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import IndicatorQualitometer from '../indicator/IndicatorQualitometer'
import MoleculeDetectedChartPanel from './MoleculeDetectedChartPanel'
import FilterParameterChartPanel from './FilterParameterChartPanel'
import { find, orderBy, reduce } from 'lodash'
import DtoDetailStationSamplingSurfacePoint from '../../dto/DtoDetailStationSamplingSurfacePoint'
import DtoAnalysis from '../../dto/DtoAnalysis'
import DtoPickupOperation from '../../dto/DtoPickupOperation'
import DtoParameter from '../../../referential/dto/DtoParameter'
import DtoSupport from '../../../referential/dto/DtoSupport'
import Select from '../../../components/select/Select'
import i18n from 'simple-react-i18n'

class QualitometerPanel extends Component {
	constructor(props) {
		super(props)
		this.state = {
			selectedValue: '1340',
			selectedSupport: '3'
		}
	}

	getMoleculeDetectedChart = () => {
		if (this.props.pickupOperations.length > 0) {
			return (
				<MoleculeDetectedChartPanel/>
			)
		}
		return ''
	}
	change = (value) => {
		this.setState({ selectedValue: value })
	}
	changeSupport = (value) => {
		this.setState({ selectedSupport: value })
	}
	getTitle = (list, filterId) => {
		if (list && list.length > 0 && filterId) {
			const result = find(list, (o) => {
				return o.id == filterId
			})
			if (result) {
				return result.name
			}
			return filterId
		}
		return filterId
	}

	getSelectedParameters = () => {
		const nbParametes = reduce(this.props.analysis, (result, value) => {
			if (result[value.parameters]) {
				result[value.parameters] = result[value.parameters] + 1
			} else {
				result[value.parameters] = 1
			}
			return result
		}, {})

		const parameters = Object.keys(nbParametes).map((parameter) => {
			if (parameter === this.state.selectedValue) {
				return {
					id: parameter,
					label: this.getTitle(this.props.parameters, parameter),
					selected: true
				}
			}
			return {
				id: parameter,
				label: this.getTitle(this.props.parameters, parameter)
			}
		})
		const data = orderBy(parameters, ['label'], ['asc'])
		return (
			<Select values={ data } title={ i18n.parameters }
					change={ this.change }/>
		)
	}
	getSelectedSupport = () => {
		const nbSupport = reduce(this.props.analysis, (result, value) => {
			if (value.support) {
				if (result[value.support]) {
					result[value.support] = result[value.support] + 1
				} else {
					result[value.support] = 1
				}
			}
			return result
		}, {})
		const supports = Object.keys(nbSupport).map((support) => {
			if (support === this.state.selectedSupport) {
				return {
					id: support,
					label: this.getTitle(this.props.supports, support),
					selected: true
				}
			}
			return {
				id: support,
				label: this.getTitle(this.props.supports, support)
			}
		})
		const data = orderBy(supports, ['label'], ['asc'])
		if (data.length > 1) {
			return (
				<Select values={ data } title={ i18n.support }
						change={ this.changeSupport }/>
			)
		}
		return (
			<Select values={ data } title={ i18n.support }
					change={ this.changeSupport } disabled/>
		)
	}

	render() {
		if (this.props.pickupOperations.length > 0) {
			return (
				<div className='row no-margin card-title'>
					<div className='col s12 m12 l12 '>
						<div className='row no-margin white-background'>
							<div className='col s12 m12 l12 no-padding card-title hide-on-med-and-down no-margin'>
								<IndicatorQualitometer/>
							</div>
						</div>
						<div className='row no-margin white-background'>
							<div className='col s12 m8 l8 no-padding'>
								<div className='row no-margin'>
									<div className='col s12 m6 l6 no-padding'>
										{ this.getSelectedParameters() }
									</div>
									<div className='col s12 m6 l6 no-padding'>
										{ this.getSelectedSupport() }
									</div>

									<FilterParameterChartPanel selectedValue={ this.state.selectedValue }
															   selectedSupport={ this.state.selectedSupport }/>
								</div>
							</div>
							<div className='col s6 m4 l4 no-padding'>
								<div className='row no-margin'>
									{ this.getMoleculeDetectedChart() }
								</div>
							</div>
						</div>
					</div>
				</div>
			)
		}
		return (
			<div className='col s12 m12 l12 card-title hide-on-med-and-down no-margin' id='qualitometerPanel'>
				{ i18n.noDataAvailableQuality }
			</div>
		)
	}
}

QualitometerPanel.propTypes = {
	id: PropTypes.string,
	samplingSurfacePoints: PropTypes.arrayOf(PropTypes.instanceOf(DtoDetailStationSamplingSurfacePoint)),
	pickupOperations: PropTypes.arrayOf(PropTypes.instanceOf(DtoPickupOperation)),
	analysis: PropTypes.arrayOf(PropTypes.instanceOf(DtoAnalysis)),
	parameters: PropTypes.arrayOf(PropTypes.instanceOf(DtoParameter)),
	supports: PropTypes.arrayOf(PropTypes.instanceOf(DtoSupport))
}

const mapStateToProps = store => {
	return {
		samplingSurfacePoints: store.DetailStationReducer.samplingSurfacePoints,
		pickupOperations: store.DetailStationReducer.pickupOperations,
		analysis: store.DetailStationReducer.analysis,
		parameters: store.ReferentialReducer.parameters,
		supports: store.ReferentialReducer.supports
	}
}

export default connect(mapStateToProps)(QualitometerPanel)



// WEBPACK FOOTER //
// ./src/station/components/qualitometer/QualitometerPanel.js